import { render, staticRenderFns } from "./SsoStep1.vue?vue&type=template&id=30081820&"
import script from "./SsoStep1.vue?vue&type=script&lang=js&"
export * from "./SsoStep1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports